import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../modal/modal.jsx';
import './UserMessageModal.css';

function UserMessageModal({ isOpen, onClose, user }) {
    const [message, setMessage] = useState('');

    const handleClose = () => {
        setMessage('');
        onClose();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!message.trim()) return;
        setMessage('');
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={handleClose} className="modal-content user-message-modal">
            <div className="user-message-modal__header">
                <h2>Wyślij wiadomość</h2>
                {user?.nickname && (
                    <span className="user-message-modal__sub">
                        Do: {user.nickname}
                    </span>
                )}
            </div>
            <form className="user-message-modal__form" onSubmit={handleSubmit}>
                <textarea
                    className="user-message-modal__textarea"
                    placeholder="Wpisz wiadomość..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    rows={6}
                />
                <div className="user-message-modal__actions">
                    <button type="submit" className="user-message-modal__send">
                        Wyślij
                    </button>
                </div>
            </form>
        </Modal>
    );
}

UserMessageModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    user: PropTypes.shape({
        nickname: PropTypes.string,
    }),
};

UserMessageModal.defaultProps = {
    user: null,
};

export default UserMessageModal;
